import { render } from "./StudentRegisterCreateAccountForm.vue?vue&type=template&id=e8f4c998"
import script from "./StudentRegisterCreateAccountForm.vue?vue&type=script&lang=js"
export * from "./StudentRegisterCreateAccountForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/evanrthompson/Projects/Classward/_Sites/emtprep.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__